import React from "react";
import { showWaitlistAtom } from "./analysisAtoms";
import { SwitchControl } from "./SwitchControl";
export const WaitlistSwitchControl = () => {
    return (
        <SwitchControl
            atom={showWaitlistAtom}
            label="Show waitlist requests"
            name="waitlist"
        />
    );
};
